import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import { listDevicesUrl } from "../../config";
import { RootState } from "../../store";
import api from '../../api';
import { IDeviceState, IDeviceApi } from "../../common/types/devicesTypes";
import { DefaultTopLevelGroup } from '../../common/constants';

const GET_DEVICES = "getDevices"

const initialState: IDeviceState = {
  devices: null,
  status: Status.IDLE,
  error: null,
};

export const fetchDeviceData = createAsyncThunk(
  GET_DEVICES,
  async (filter: string) => {
    try {
      const encodedFilter = filter ? encodeURIComponent(filter) : '';
      const url = listDevicesUrl + `?filter=${encodedFilter}` + `&orgId=${DefaultTopLevelGroup.ID}`;
      const response = await api.get<IDeviceApi>(url);
      const deviceData: IDeviceApi = response.data;
      return deviceData;
    } catch (error) {
      throw error;
    }
  }
);

const deviceSlice = createSlice({
  name: GET_DEVICES,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDeviceData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(fetchDeviceData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.devices = action.payload;
      })
      .addCase(fetchDeviceData.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
      });
  },
});

export const actions = {
  deviceSlice,
  ...deviceSlice.actions,
};

export const selector = (state: RootState) => state.deviceApi;

export const reducer = deviceSlice.reducer;
